// Velodrome V3 Factory ABI - based on the transaction analysis
// The Velodrome factory emits different events than the Relay factory

export const VELODROME_FACTORY_ABI = [
  // Events that we need to parse from Velodrome deployments
  {
    "anonymous": false,
    "inputs": [
      {"indexed": false, "internalType": "address", "name": "tokenAddress", "type": "address"},
      {"indexed": false, "internalType": "string", "name": "name", "type": "string"},
      {"indexed": false, "internalType": "string", "name": "symbol", "type": "string"},
      {"indexed": true, "internalType": "address", "name": "creator", "type": "address"}
    ],
    "name": "TokenDeployed",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {"indexed": false, "internalType": "address", "name": "pool", "type": "address"}
    ],
    "name": "PoolInitialized", 
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {"indexed": false, "internalType": "address", "name": "pool", "type": "address"},
      {"indexed": false, "internalType": "address", "name": "token0", "type": "address"},
      {"indexed": false, "internalType": "address", "name": "token1", "type": "address"},
      {"indexed": false, "internalType": "uint24", "name": "fee", "type": "uint24"}
    ],
    "name": "PoolCreated",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {"indexed": false, "internalType": "uint256", "name": "tokenId", "type": "uint256"},
      {"indexed": true, "internalType": "address", "name": "creator", "type": "address"}
    ],
    "name": "LiquidityMinted",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {"indexed": false, "internalType": "uint256", "name": "tokenId", "type": "uint256"},
      {"indexed": true, "internalType": "address", "name": "creator", "type": "address"}
    ],
    "name": "NFTLocked",
    "type": "event"
  },
  // ERC-20 Transfer event - this is how we get the pool address!
  // Tokens are transferred from factory -> pool during deployment
  {
    "anonymous": false,
    "inputs": [
      {"indexed": true, "internalType": "address", "name": "from", "type": "address"},
      {"indexed": true, "internalType": "address", "name": "to", "type": "address"},
      {"indexed": false, "internalType": "uint256", "name": "value", "type": "uint256"}
    ],
    "name": "Transfer",
    "type": "event"
  },
  // Position Manager events (these might contain pool address)
  {
    "anonymous": false,
    "inputs": [
      {"indexed": false, "internalType": "address", "name": "sender", "type": "address"},
      {"indexed": false, "internalType": "address", "name": "owner", "type": "address"},
      {"indexed": false, "internalType": "int24", "name": "tickLower", "type": "int24"},
      {"indexed": false, "internalType": "int24", "name": "tickUpper", "type": "int24"},
      {"indexed": false, "internalType": "uint128", "name": "amount", "type": "uint128"},
      {"indexed": false, "internalType": "uint256", "name": "amount0", "type": "uint256"},
      {"indexed": false, "internalType": "uint256", "name": "amount1", "type": "uint256"}
    ],
    "name": "Mint",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {"indexed": false, "internalType": "address", "name": "pool", "type": "address"},
      {"indexed": false, "internalType": "address", "name": "token0", "type": "address"},
      {"indexed": false, "internalType": "address", "name": "token1", "type": "address"},
      {"indexed": false, "internalType": "uint24", "name": "fee", "type": "uint24"},
      {"indexed": false, "internalType": "int24", "name": "tickSpacing", "type": "int24"}
    ],
    "name": "PoolCreated",
    "type": "event"
  },
  // Function signatures (we don't need these for parsing, but good to have)
  {
    "inputs": [
      {"internalType": "string", "name": "_name", "type": "string"},
      {"internalType": "string", "name": "_symbol", "type": "string"},
      {"internalType": "uint8", "name": "poolManagerTier", "type": "uint8"}
    ],
    "name": "newMavrkToken",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];

// Velodrome factory address
export const VELODROME_FACTORY_ADDRESS = '0x1DD36609eFCB0208C415fE318A95baC1dB4252Fd';

// Helper function to get the correct factory ABI based on LP provider
export function getFactoryABI(lpProvider?: string) {
  if (lpProvider === 'velodrome') {
    return VELODROME_FACTORY_ABI;
  }
  
  // Default to V2 factory ABI (with npm parameter)
  return [
    {"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"tokenAddress","type":"address"},{"indexed":false,"internalType":"string","name":"name","type":"string"},{"indexed":false,"internalType":"string","name":"symbol","type":"string"},{"indexed":true,"internalType":"address","name":"creator","type":"address"},{"indexed":true,"internalType":"address","name":"npm","type":"address"},{"indexed":false,"internalType":"uint256","name":"totalDeployed","type":"uint256"}],"name":"TokenDeployed","type":"event"},
    {"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"pool","type":"address"},{"indexed":false,"internalType":"address","name":"npm","type":"address"}],"name":"PoolInitialized","type":"event"},
    {"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":true,"internalType":"address","name":"creator","type":"address"},{"indexed":false,"internalType":"address","name":"npm","type":"address"}],"name":"LiquidityMinted","type":"event"},
    {"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":true,"internalType":"address","name":"creator","type":"address"}],"name":"NFTLocked","type":"event"},
    {"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"}
  ];
}

// Helper function to get the correct factory address based on LP provider
export function getFactoryAddress(lpProvider?: string) {
  if (lpProvider === 'velodrome') {
    return VELODROME_FACTORY_ADDRESS;
  }
  
  // Default to V3 factory address (self-custody LP NFTs)
  return '0xE01118dbcF8Ba2609d3ffBD6A53d9533c7526D60';
}
